export default __webpack_public_path__ + "static/media/diversity.a9cb6db4.svg";